import { Box } from '@mui/material';
import React from 'react';

interface CellTextProps {
  muted: boolean;
  children: React.ReactNode;
}

export const CellText = ({ muted, children }: CellTextProps) => (
  <Box component="span" color={muted ? 'grey.500' : 'inherit'}>
    {children}
  </Box>
);
